import { useState, useRef, useCallback, useEffect } from 'react';

export const usePreventClickDuringInteraction = (interactionTimeout = 300) => {
  const [isInteracting, setIsInteracting] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const extendInteraction = useCallback(() => {
    if (!isInteracting) setIsInteracting(true);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      setIsInteracting(false);
      timeoutRef.current = null;
    }, interactionTimeout);
  }, [interactionTimeout, isInteracting]);

  const preventClick = useCallback(
    (e: Event) => {
      if (isInteracting) {
        e.preventDefault();
        e.stopPropagation();
        return true;
      }
      return false;
    },
    [isInteracting]
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return {
    isInteracting,
    startInteraction: extendInteraction,
    preventClick,
  };
};
